import { Component, Fragment} from "react";
import * as React from "react";
import EditableCard from "./pages/onboard/EditableCard";
import { IconButton, ActionButton, Toggle } from "office-ui-fabric-react";
import { SchoolWorkloadConfig, sortYearGroupingsByIsAfterValues, YearGrouping } from "../models/SchoolWorkloadConfig";
import * as _ from "lodash";
import DispatchProps from "../utils/DispatchProps";

export interface YearGroupingsEditorProps
{
    yearGroupings: YearGrouping[];
    onYearGroupingChange: (YearGroup: YearGrouping[]) => void;
    aggregatePermissions: boolean;
    onAggregatePermissionsChanged: (choice: boolean) => void;
    schoolWorkloadConfig?: SchoolWorkloadConfig;
}

interface YearGroupingsEditorState
{
}

export default class YearGroupingEditor extends Component<YearGroupingsEditorProps,YearGroupingsEditorState>
{

    constructor(props: Readonly<YearGroupingsEditorProps>) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
        var clonedSortedYearGroups = _.cloneDeep(sortYearGroupingsByIsAfterValues(this.props.yearGroupings));

        this.setState({newYearGroupings: clonedSortedYearGroups})
    }

    async componentDidUpdate(prevProps: Readonly<YearGroupingsEditorProps & DispatchProps>, prevState: YearGroupingsEditorState): Promise<void> {
        
    }

    private onRename = (yearGroupingToRename: YearGrouping, newName: string): void => {

        const existingIndex = this.props.yearGroupings.indexOf(yearGroupingToRename);

        const newItems = _.without(this.props.yearGroupings, yearGroupingToRename);

        const renamedYearGrouping = _.cloneDeep(yearGroupingToRename);
        renamedYearGrouping.name = newName;

        newItems.splice(existingIndex, 0, renamedYearGrouping);

        const yearGroupingAfter = this.props.yearGroupings.filter(yg => yg.isAfter === yearGroupingToRename.name)[0];
        if (yearGroupingAfter) {
            const indexOfYearGroupingAfter = newItems.indexOf(yearGroupingAfter);

            const newYearGroupingAfter = _.cloneDeep(yearGroupingAfter);
            newYearGroupingAfter.isAfter = newName;

            newItems.splice(indexOfYearGroupingAfter, 1, newYearGroupingAfter);
        }

        this.props.onYearGroupingChange(newItems);
    };

    private onDelete = (yearGroupingToDelete: YearGrouping): void => {

        const newItems = _.without(this.props.yearGroupings, yearGroupingToDelete)

        this.props.onYearGroupingChange(newItems);

    }

    private onAdd = (): void => {

        const newItem = { name: "" } as YearGrouping
        const yearGroupingItems = [...this.props.yearGroupings, newItem];

        this.props.onYearGroupingChange(yearGroupingItems);
    }

    private moveYearGrouping(yearGroupingToMove: YearGrouping, offset: number): void {

        const currentIndex = this.props.yearGroupings.indexOf(yearGroupingToMove);
        const newIndex = currentIndex + offset;
        if (newIndex >= this.props.yearGroupings.length || newIndex < 0) {
            console.log("Can't move year grouping to index ", newIndex);
            return;
        }

        const yearGroupingItems = _.without(this.props.yearGroupings, yearGroupingToMove)
        yearGroupingItems.splice(newIndex, 0, yearGroupingToMove);

        this.props.onYearGroupingChange(yearGroupingItems);
    }



    public render() {

        const yearGroupingCards = this.props.yearGroupings.map(yg => {
            return (
                <EditableCard
                    key={yg.name}
                    item={yg}
                    namePropertyName={"name"}
                    onRename={this.onRename}
                    onDelete={this.onDelete}
                >
                    <IconButton iconProps={{ iconName: "ChevronUp" }} title="Move Earlier" ariaLabel="Move Earlier" onClick={() => this.moveYearGrouping(yg, -1)} />
                    <IconButton iconProps={{ iconName: "ChevronDown" }} title="Move Later" ariaLabel="Move Later" onClick={() => this.moveYearGrouping(yg, 1)} />
                </EditableCard>
            );
        });

        return (
            <Fragment>

                {this.props.schoolWorkloadConfig?.yearGroupings.aggregatePermissions! ? null : <Toggle
                    className={"m-top-1rem flex-row flex--align-items-center"}
                    title={"Switch on aggregate permissions for school"}
                    label={"Aggregate Permissions: "}
                    hidden={this.props.schoolWorkloadConfig?.yearGroupings.aggregatePermissions!}
                    disabled={this.props.schoolWorkloadConfig?.yearGroupings.aggregatePermissions!}
                    checked={this.props.aggregatePermissions}
                    onChange={(event, newValue) => {
                        this.props.onAggregatePermissionsChanged(newValue!)
                    }}
                    role="checkbox"
                />}

                {yearGroupingCards}

                <ActionButton
                    className={"m-top-05rem"}
                    iconProps={{ iconName: "Add" }}
                    text="Add Year Grouping"
                    disabled={false}
                    checked={false}
                    onClick={this.onAdd}
                />
            </Fragment>
        );
    }
}